/**
 * Constantes de l'essai gratuit (Volet A — gating d'accès).
 *
 * Un essai de {@link TRIAL_DURATION_DAYS} jours est démarré automatiquement à
 * l'inscription (aucune CB demandée). Pendant l'essai :
 *  - le marketing/campagne est bloqué dur (zéro envoi),
 *  - le transactionnel (rappels RDV, confirmations) reste autorisé mais plafonné
 *    à un petit quota de découverte ({@link TRIAL_TRANSACTIONAL_EMAIL_QUOTA} /
 *    {@link TRIAL_TRANSACTIONAL_SMS_QUOTA}) — anti-abus, et le pro peut tester le
 *    tunnel de réservation de bout en bout,
 *  - les emails système (reset password, invitation équipe) passent toujours.
 *
 * cf. docs/to_implement/trial-period-plan.md (§4).
 */
export const TRIAL_DURATION_DAYS = 7;

/**
 * Période de grâce annoncée au pro à la fin de l'essai (« on garde votre espace 30 jours »,
 * messages R-J6 / R-J7 de la relance des essais). Le lien de reprise reste valable pendant
 * toute cette fenêtre : sans ça, le mail qui promet 30 jours porte un lien qui meurt le soir
 * même. cf. docs/to_implement/trial-relance-messages.md (R-J7).
 */
export const TRIAL_RESUME_GRACE_DAYS = 30;

/**
 * Essai accordé à un compte CRÉÉ PAR L'ADMIN depuis Cfixé v1 (« créer + migrer » en un
 * geste, page Bascule finale). Plus long que l'essai d'inscription : le pro migré n'a
 * rien à construire, il attend la bascule de son abonnement. Aucun email de bienvenue ni
 * relance d'essai ne part pour ces comptes (`professional.is_migrated` dès la création).
 */
export const MIGRATED_V1_TRIAL_DAYS = 30;

// Plafond « découverte » du transactionnel pendant l'essai (anti-abus).
// Marketing = 0 (bloqué dur via isMarketingAllowed).
export const TRIAL_TRANSACTIONAL_EMAIL_QUOTA = 10;
export const TRIAL_TRANSACTIONAL_SMS_QUOTA = 10;
